import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Utils } from '../../../_helpers/utilities';

@Injectable()
export class DashboardGuard  {

  constructor(
    private _router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const loggedIn = Utils.isAuthenticated();
    if (loggedIn) {
      return loggedIn;
    }

    //replaceUrl is used to replace current state in history with new one
    this._router.navigate(['login'], { queryParams: { next: state.url }, replaceUrl: true });
    return false;
  }
}
